module["exports"] = [
  "구",
  "시",
  "군"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ko/address/city_suffix.js
// module id = 1711
// module chunks = 1